import { z } from 'zod';
import { Status } from '@pillar-portal/database/dist/frontend';

export const isoSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255, 'Name is too long'),
    parent_organization_uuid: z.string().optional(),
});

export const merchantSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255, 'Name is too long'),
    parent_organization_uuid: z.string().optional(),
});

export const editOrgSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255, 'Name is too long'),
    status: z.nativeEnum(Status),
});

export const reassignMerchantSchema = z.object({
    iso_id: z.string().regex(/^\d+$/, 'ISO ID must be a numeric string'),
});
